// extracted by mini-css-extract-plugin
export default {"background":"ksLTxo4Hp7TLQ47zv3I1"};